/**
 * LoginPortal biometric opt-in preference (localStorage on the Gateway origin).
 * Enabled from Header WMS registration (synced on logout via query/cookie) or written
 * locally when the Gateway origin is shared with the tenant (lab same-origin).
 *
 * Preprod cross-origin: Tiger nativo aterriza en ?logged_out=1 sin query; begin-logout
 * deja cookie wms_login_biometric_enabled=1 (no HttpOnly) que consumimos aquí.
 */

export const SE_PREGUNTO_BIOMETRIA_KEY = 'sepreguntobiometria';
export const LOGIN_BIOMETRIC_ENABLED_KEY = 'wms_login_biometric_enabled';

function readFlag(key) {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
}

function writeFlag(key, value) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(key, value ? 'true' : 'false');
  } catch {
    /* quota / private mode */
  }
}

function readCookie(name) {
  if (typeof document === 'undefined') return null;
  try {
    const prefix = `${name}=`;
    const part = String(document.cookie || '')
      .split(';')
      .map((s) => s.trim())
      .find((s) => s.startsWith(prefix));
    if (!part) return null;
    return decodeURIComponent(part.slice(prefix.length));
  } catch {
    return null;
  }
}

function clearCookie(name) {
  if (typeof document === 'undefined') return;
  try {
    const base = `${name}=; Path=/; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`;
    document.cookie = base;
    if (typeof window !== 'undefined' && window.location?.protocol === 'https:') {
      document.cookie = `${base}; Secure`;
    }
  } catch {
    /* ignore */
  }
}

export function wasBiometricPromptAnswered() {
  return readFlag(SE_PREGUNTO_BIOMETRIA_KEY);
}

export function isLoginBiometricEnabled() {
  return readFlag(LOGIN_BIOMETRIC_ENABLED_KEY);
}

export function setBiometricLoginPreference(enabled) {
  writeFlag(SE_PREGUNTO_BIOMETRIA_KEY, true);
  writeFlag(LOGIN_BIOMETRIC_ENABLED_KEY, Boolean(enabled));
}

/**
 * Consume cookie Gateway de opt-in (begin-logout) → localStorage.
 * @returns {boolean} true si había cookie activa y se persistió el opt-in
 */
export function consumeBiometricOptInCookie() {
  const raw = readCookie(LOGIN_BIOMETRIC_ENABLED_KEY);
  if (raw == null) return false;
  clearCookie(LOGIN_BIOMETRIC_ENABLED_KEY);
  const enabled = raw === '1' || raw === 'true';
  if (!enabled) return false;
  setBiometricLoginPreference(true);
  return true;
}
